
export const countryRules = {
  "+91": { min: 10, max: 10, country: "India" },
  "+1": { min: 10, max: 10, country: "USA/Canada" },
  "+44": { min: 10, max: 11, country: "United Kingdom" },
  "+971": { min: 9, max: 9, country: "UAE" },
  "+61": { min: 9, max: 9, country: "Australia" },
  "+81": { min: 10, max: 11, country: "Japan" },
  "+49": { min: 10, max: 11, country: "Germany" },
  "+33": { min: 9, max: 9, country: "France" },
  "+86": { min: 11, max: 11, country: "China" },
  "+7": { min: 10, max: 10, country: "Russia/Kazakhstan" },
  "+65": { min: 8, max: 8, country: "Singapore" },
  "+60": { min: 9, max: 10, country: "Malaysia" },
  "+92": { min: 10, max: 10, country: "Pakistan" },
  "+880": { min: 10, max: 10, country: "Bangladesh" },
  "+94": { min: 9, max: 9, country: "Sri Lanka" },
  "+977": { min: 10, max: 10, country: "Nepal" },
  "+966": { min: 9, max: 9, country: "Saudi Arabia" },
  "+20": { min: 10, max: 10, country: "Egypt" },
  "+27": { min: 9, max: 9, country: "South Africa" },
  "+34": { min: 9, max: 9, country: "Spain" },
  "+39": { min: 9, max: 10, country: "Italy" },
  "+31": { min: 9, max: 9, country: "Netherlands" },
  "+32": { min: 9, max: 9, country: "Belgium" },
  "+41": { min: 9, max: 9, country: "Switzerland" },
  "+46": { min: 9, max: 9, country: "Sweden" },
  "+47": { min: 8, max: 8, country: "Norway" },
  "+45": { min: 8, max: 8, country: "Denmark" },
  "+48": { min: 9, max: 9, country: "Poland" },
  "+351": { min: 9, max: 9, country: "Portugal" },
  "+30": { min: 10, max: 10, country: "Greece" },
  "+82": { min: 9, max: 10, country: "South Korea" },
  "+84": { min: 9, max: 10, country: "Vietnam" },
  "+66": { min: 9, max: 9, country: "Thailand" },
  "+62": { min: 9, max: 12, country: "Indonesia" },
  "+63": { min: 10, max: 10, country: "Philippines" },
  "+64": { min: 8, max: 10, country: "New Zealand" },
  "+55": { min: 10, max: 11, country: "Brazil" },
  "+52": { min: 10, max: 10, country: "Mexico" },
  "+54": { min: 10, max: 11, country: "Argentina" },
  "+56": { min: 9, max: 9, country: "Chile" },
  "+90": { min: 10, max: 10, country: "Turkey" },
  "+98": { min: 10, max: 10, country: "Iran" },

  // 🌍 Default fallback (covers remaining countries)
  "default": { min: 7, max: 15, country: "Other" }
};

/**
 * Returns a Yup test configuration for phone number validation based on country rules.
 * @param {string} currentCountryCode - The selected country prefix (e.g., '+91')
 */
export const getPhoneValidation = (currentCountryCode) => {
  const rules = countryRules[currentCountryCode] || countryRules["default"];
  return {
    name: "phone-length",
    message: `Phone for ${rules.country} must be ${
      rules.min === rules.max ? rules.min : `${rules.min}-${rules.max}`
    } digits`,
    test: (value) => {
      if (!value) return true;
      const digits = value.toString().replace(/\D/g, "");
      return digits.length >= rules.min && digits.length <= rules.max;
    },
  };
};
